import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function usePlayables({ podcastId, episodeId, configs = {}, enabled = false }) {
  const { privateFetch } = useContext(FetchContext);
  const { params = {} } = configs;

  const getPlayables = async () => {
    const response = await privateFetch.get(
      `/v1/admin/podcast/${podcastId}/episode/${episodeId}/playable`,
      { params }
    );
    return response.data.data;
  };

  return useQuery(['episode-playables', podcastId, episodeId, params], getPlayables, {
    enabled,
    keepPreviousData: true,
  });
}

export default usePlayables;
